import { ArticleItem } from '../../types';

export const marchMedicalDeviceReviewDataEn: ArticleItem = {
  slug: "march-medical-device-review-data",
  title: "March Medical Device Review Data Released: Multiple Workstreams Advanced in Parallel",
  summary: "March medical device review data shows synchronized progress across registration review, acceptance, supplementary materials, expert consultation, quality system verification, innovation review, and priority approval.",
  seo: {
    title: "March Medical Device Review Data Released | HL Medical",
    description: "March medical device review data summarizes registration applications, acceptance, supplementary materials, expert consultation, quality system verification, innovation review, and priority approval.",
    keywords: "medical device review data, March medical device registration, CMDE review, innovative medical device review, priority approval",
    canonicalUrl: "https://hlmedicalconsult.cn/en/articles/march-medical-device-review-data",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/march-medical-device-review-data",
      cn: "https://hlmedicalconsult.cn/cn/articles/march-medical-device-review-data",
      xDefault: "https://hlmedicalconsult.cn/en/articles/march-medical-device-review-data"
    },
    ogTitle: "March Medical Device Review Data Released",
    ogDescription: "Multiple medical device review workstreams advanced in parallel in March.",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "Regulatory Review",
  readTime: "2 min read",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "March Review Data" },
    { type: "paragraph", text: "March medical device review data has been released, showing that multiple workstreams advanced in parallel." },
    {
      type: "table",
      columns: ["Category", "Item", "Count"],
      rows: [
        ["Registration application matters", "Applications transferred into technical review", "1,560 items"],
        ["Registration application matters", "Projects transferred out after review completion", "1,373 items"],
        ["Registration application acceptance", "Registration applications accepted", "2,333 items"],
        ["Registration application acceptance", "Change filings", "719 items"],
        ["Registration application acceptance", "Imported Class I device filings", "230 items"],
        ["Supplementary and correction materials", "Supplementary material notices issued by the center", "705 notices"],
        ["Supplementary and correction materials", "Correction materials received", "684 submissions"],
        ["Expert consultation meetings", "Expert consultations initiated", "33 items"],
        ["Expert consultation meetings", "Expert consultation meetings organized", "14 meetings"],
        ["Registration quality management system inspection", "Registration QMS inspections initiated", "358 items"],
        ["Registration quality management system inspection", "Inspection results received", "246 items"],
        ["Special review for innovative medical devices", "Innovation applications accepted", "51 items"],
        ["Special review for innovative medical devices", "Expert review meetings organized", "42 meetings"],
        ["Special review for innovative medical devices", "Reviews completed", "43 items"],
        ["Priority approval medical device review", "Priority approval applications accepted", "6 items"],
        ["Priority approval medical device review", "Reviews completed", "5 items"]
      ]
    }
  ]
};

export const marchMedicalDeviceReviewDataCn: ArticleItem = {
  slug: "march-medical-device-review-data",
  title: "3月器械审评数据新鲜出炉：多项工作同步推进",
  summary: "3月医疗器械审评数据展示注册申请、受理、补充资料、专家咨询、体系核查、创新审查和优先审批等多项工作进展。",
  seo: {
    title: "3月器械审评数据新鲜出炉：多项工作同步推进 | 赫莱医药",
    description: "3月医疗器械审评数据汇总注册申请事项、注册申请受理、补充资料、专家咨询会议、体系核查、创新审查和优先审批情况。",
    keywords: "医疗器械审评数据, 3月器械审评, 医疗器械注册, 创新医疗器械特别审查, 优先审批医疗器械",
    canonicalUrl: "https://hlmedicalconsult.cn/cn/articles/march-medical-device-review-data",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/march-medical-device-review-data",
      cn: "https://hlmedicalconsult.cn/cn/articles/march-medical-device-review-data",
      xDefault: "https://hlmedicalconsult.cn/en/articles/march-medical-device-review-data"
    },
    ogTitle: "3月器械审评数据新鲜出炉：多项工作同步推进",
    ogDescription: "3月医疗器械审评多项工作同步推进，涵盖注册审评、体系核查、创新审查和优先审批等。",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "注册审评",
  readTime: "约2分钟",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "3月审评数据" },
    { type: "paragraph", text: "3月器械审评数据新鲜出炉，多项工作同步推进。" },
    {
      type: "table",
      columns: ["类别", "项目", "数量"],
      rows: [
        ["注册申请事项情况", "转入技术审评程序的各类申请事项", "1560项"],
        ["注册申请事项情况", "转出审结项目", "1373项"],
        ["注册申请受理", "受理注册申请", "2333项"],
        ["注册申请受理", "变更备案", "719项"],
        ["注册申请受理", "进口一类备案", "230项"],
        ["补充资料及补正资料", "中心发出补充资料通知单", "705份"],
        ["补充资料及补正资料", "接收补正资料", "684份"],
        ["专家咨询会议情况", "启动专家咨询", "33项"],
        ["专家咨询会议情况", "组织召开专家咨询会议", "14次"],
        ["注册质量管理体系核查", "启动注册质量管理体系核查", "358项"],
        ["注册质量管理体系核查", "接收核查结果", "246项"],
        ["创新医疗器械特别审查", "受理创新申请", "51项"],
        ["创新医疗器械特别审查", "组织召开专家审查会", "42次"],
        ["创新医疗器械特别审查", "完成审查", "43项"],
        ["优先审批医疗器械审核", "受理优先审批申请", "6项"],
        ["优先审批医疗器械审核", "完成审核", "5项"]
      ]
    }
  ]
};
